module.exports = __webpack_public_path__ + "static/media/icn-ledger.a73415b7.svg";